import { createAction } from '@reduxjs/toolkit';

import { FetchMonetizationDataPayload } from './monetizationTypes';

export const fetchMonetizationData = createAction<FetchMonetizationDataPayload>(
  'monetization/fetchMonetizationData'
);

export const fetchMonetizationErrorMessage = createAction<string>(
  'monetization/fetchMonetizationErrorMessage'
);
